<template>
  <div
    class="status-panel"
    :style="borderColor"
  >
    <div class="is-flex" style="flex-wrap: wrap">
      <div class="is-flex flex-align--center grow">
        <div
          class="icon-color"
          style="margin: 1rem; font-size: 12px;"
        >
          <font-awesome-icon
            size="3x"
            :icon="matchStatusIcon"
          />
        </div>
        <div class="is-flex flex-direction--column flex-align--start">
          <div
            v-html="matchStatus"
            class="status-panel--header"
          >
          </div>
          <div
            class="subtext-font-size"
            style="color: #666"
          >
            {{ matchDescription }}
          </div>
          <div
            class="subtext-font-size"
            style="color: #666"
          >
            {{ matchUserDescription }} on {{ statusDate }}
          </div>
        </div>
      </div>
      <div class="is-flex">
        <div class="
              status-panel--actions
              is-flex
              flex-direction--column
              flex-justify--center
              flex-align--start
              subtext-font-size">
          <router-link
            v-if="pendingCount"
            :to="{
              path: `/personId/nearMatches`,
              query: {
                pidBatchId: batchId
              }
            }"
          >
            View Pending {{ properties['SYSTEM_LABEL-NEARMATCH'] }} List
          </router-link>
          <router-link
            v-if="pendingCount < 1"
            :to="{
              path: `/personId`
            }"
          >
            View Home Page
          </router-link>
          <router-link
            :to="{
              path: `/personId/individualMatch/${nearMatchId}/details`
            }"
          >
            View Transaction Details
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faExclamationCircle,
  faStopCircle,
  faQuestionCircle,
  faWindowClose,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faCheckCircle,
  faExclamationCircle,
  faStopCircle,
  faQuestionCircle,
  faWindowClose,
);

export default {
  props: {
    batchId: {
      stype: Number,
    },
    decisionStatus: {
      type: String,
    },
    nearMatches: {
      type: Array,
    },
    isResolvedMatch: {
      type: Boolean,
    },
    isResolvedNoMatch: {
      type: Boolean,
    },
    matchStatusIcon: {
      type: Array,
      required: true,
    },
    nearMatchId: {
      type: [String, Number],
      // required: true,
    },
    pendingCount: {
      type: Number,
    },
    newlyCreatedId: {
      type: [String, Number],
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    borderColor() {
      let color;
      if (this.decisionStatus === 'Pending') {
        color = '#ed7d31';
      } else if (this.decisionStatus === 'Canceled') {
        color = '#c00000';
      } else if (this.isResolvedMatch) {
        color = '#28a745';
      } else if (this.isResolvedNoMatch) {
        color = '#0070c0';
      }
      return `border-left: 10px solid ${color}`;
    },
    matchDescription() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = 'A Match Decision is required.';
      } else if (this.decisionStatus === 'Canceled') {
        s = 'The submission record has been canceled.';
      } else if (this.isResolvedMatch) {
        s = 'The submission record was matched to an existing record.';
      } else if (this.isResolvedNoMatch) {
        s = 'The submission record was not matched to an existing record.';
      }
      return s;
    },
    matchUserDescription() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = `Record submitted by ${this.user}`;
      } else if (this.decisionStatus === 'Canceled') {
        s = `Canceled by: ${this.user}`;
      } else if (this.isResolvedMatch || this.isResolvedNoMatch) {
        s = `Resolved by: ${this.user}`;
      }
      return s;
    },
    matchStatus() {
      let s = null;
      if (this.decisionStatus === 'Pending') {
        s = `Pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es) Queued`;
      } else if (this.decisionStatus === 'Match') {
        s = 'Match Decision';
      } else if (this.decisionStatus === 'No Match') {
        s = `No Match Decision - New ID Created: ${this.newlyCreatedId}`;
      } else if (this.decisionStatus === 'Canceled') {
        s = 'Canceled';
      }
      return s;
    },
    user() {
      let userEmail = '';
      if (this.decisionStatus === 'Pending') {
        userEmail = this.nearMatches[0].submittedByEmail;
      } else if (this.decisionStatus === 'No Match' || this.decisionStatus === 'Match' || this.decisionStatus === 'Canceled') {
        userEmail = this.nearMatches[0].resolvedByEmail;
      }
      return `${userEmail}`;
    },
    statusDate() {
      let formattedDate = '';
      if (this.decisionStatus === 'Pending') {
        formattedDate = this.formatDate(this.nearMatches[0].pidBatch.createdDate);
      } else if (this.decisionStatus === 'No Match' || this.decisionStatus === 'Match') {
        formattedDate = this.formatDate(this.nearMatches[0].resovledDate);
      } else if (this.decisionStatus === 'Canceled') {
        formattedDate = this.formatDate(this.nearMatches[0].lastUpdateDate);
      }
      return `${formattedDate}`;
    },
  },
  methods: {
    formatDate(rawDate) {
      const formattedDate = new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date(rawDate));
      return `${formattedDate}`;
    },
  },
};
</script>

<style lang="sass" scoped>
  .status-panel
    border: 1px solid #bbb
    background-color: #f9f9f9
    box-shadow: 0 0 3px #aaa
    padding: 12px 16px 12px 0
  .status-panel--header
    font-size: 20px
    margin-bottom: 0.25rem
  .status-panel--actions
    border-left: 1px solid #ccc
    padding-left: 1rem
  .subtext-font-size
    font-size: 12px
  .icon-color
    color: #BBBBBB
</style>
